/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "react-router-dom";
import { Button, Space, Typography } from "antd";
import { useLeadCapture } from "../../components/lead-capture";
const { Text } = Typography;

const Buttons = ({ single }) => {
  const openLeadCapture = useLeadCapture();
  return (
    <>
      <Space
        size="middle"
        wrap
        style={{ justifyContent: "center", marginTop: 8 }}
      >
        <Button type="primary" size="large" onClick={() => openLeadCapture()}>
          Request Access
        </Button>
        {!single && (
          <>
            <Link to="/demo">
              <Button type="default" size="large">
                Take a Tour
              </Button>
            </Link>
            <Button
              type="default"
              size="large"
              onClick={() => {
                document.getElementById("login")?.scrollIntoView({
                  behavior: "smooth",
                });
              }}
            >
              Sign in
            </Button>
          </>
        )}
      </Space>
      <Text
        type="secondary"
        style={{
          display: "block",
          marginTop: 16,
          maxWidth: 360,
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
          fontSize: 13,
          lineHeight: 1.5,
        }}
      >
        Shorted Black is currently invite-only. Reach out to us to get early
        access.
      </Text>
    </>
  );
};
export default Buttons;
